import { useEffect } from 'react';
import { useData } from '@hooks/useData';

export const useUserLocation = () => {
    const { setUserLivePosition } = useData();

    useEffect(() => {
        if (!navigator.geolocation) return;

        const watchId = navigator.geolocation.watchPosition(
            (position) => {
                setUserLivePosition([position.coords.latitude, position.coords.longitude]);
            },
            () => {
                setUserLivePosition(null);
            },
            { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
        );

        return () => navigator.geolocation.clearWatch(watchId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
